/* ==========================================================================
   Pick Card 2BOXES landing page: card game + offer reveal
   Section: sections/pick-card-offer.liquid
   Settings arrive as JSON in [data-pc2b-config]; all copy is editor-managed.
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('pick-card-2boxes-offer')) return;

  var CARD_COUNT = 9;
  var PICKS = 3;
  var CONFETTI_COLORS = ['#eda053', '#dc7a17', '#efe7d4', '#4a4a2c', '#ffffff', '#c8b98f'];
  var ICON = {
    crate: '<svg viewBox="0 0 48 48" fill="none" stroke="#eda053" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 16l18-8 18 8-18 8z"/><path d="M6 16v16l18 8V24"/><path d="M42 16v16l-18 8"/><path d="M15 12l18 8"/></svg>',
    two: '<svg viewBox="0 0 48 48" fill="none" stroke="#dc7a17" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 22l13-6 13 6-13 6z"/><path d="M3 22v11l13 6V28"/><path d="M29 22v11l-13 6"/><path d="M19 12l13-6 13 6-13 6z"/><path d="M45 12v11l-8 3.7"/></svg>',
    bag: '<svg viewBox="0 0 48 48" fill="none" stroke="#dc7a17" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="5" y="15" width="38" height="24" rx="6"/><path d="M17 15v-3a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3"/><path d="M5 25h38"/><path d="M21 25v4h6v-4"/></svg>'
  };

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* "10, 15, 20" -> one random entry; falls back when the setting is empty */
  function pickValue(list, fallback) {
    var values = String(list || '').split(',').map(function (v) { return v.trim(); }).filter(Boolean);
    if (!values.length) return fallback;
    return values[Math.floor(Math.random() * values.length)];
  }

  function money(n) { return '$' + n.toFixed(2); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function buzz(p) { if (navigator.vibrate) { try { navigator.vibrate(p); } catch (e) {} } }

  class PickCard2BoxesOffer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._timers = [];

      var raw = this.querySelector('[data-pc2b-config]');
      try { this.cfg = JSON.parse(raw ? raw.textContent : '{}'); } catch (e) { this.cfg = {}; }

      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.opened = 0;
      this.done = false;
      this.touched = false;
      this.tiles = [];

      this.el = {
        grid: this.querySelector('[data-pc2b-grid]'),
        bars: this.querySelectorAll('[data-pc2b-bars] i'),
        count: this.querySelector('[data-pc2b-count]'),
        nudge: this.querySelector('[data-pc2b-nudge]'),
        chip: this.querySelector('[data-pc2b-chip]'),
        pre: this.querySelector('[data-pc2b-dial-pre]'),
        dial: this.querySelector('[data-pc2b-dial]'),
        dialSub: this.querySelector('[data-pc2b-dial-sub]'),
        payoff: this.querySelector('[data-pc2b-payoff]'),
        price: this.querySelector('[data-pc2b-price]'),
        now: this.querySelector('[data-pc2b-now]'),
        clock: this.querySelector('[data-pc2b-clock]'),
        clockValue: this.querySelector('[data-pc2b-clock-value]'),
        sticky: this.querySelector('[data-pc2b-sticky]'),
        confetti: this.querySelector('[data-pc2b-confetti]')
      };
      if (!this.el.grid) return;

      this.steps = this.buildSteps();
      this.renderTiles();
      this.carryTrackingParams();
      this.scheduleHint();
    }

    disconnectedCallback() {
      (this._timers || []).forEach(function (t) { clearTimeout(t); clearInterval(t); });
      this._timers = [];
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    later(fn, ms) {
      var t = setTimeout(fn, ms);
      this._timers.push(t);
      return t;
    }

    /* Cards 1 and 2 are randomized "so far" progress steps, never a claimable
       discount. Card 3 is always the headline offer: the free second box. */
    buildSteps() {
      var c = this.cfg;
      var s1 = pickValue(c.step1Values, '15') + '%';
      var s2 = pickValue(c.step2Values, '30') + '%';
      return [
        { pct: s1, cap: c.stepCaption, dial: s1, dsub: c.step1Sub },
        { pct: s2, cap: c.stepCaption, dial: s2, dsub: c.step2Sub },
        {
          max: true,
          icon: ICON[c.finalIcon] ? c.finalIcon : 'two',
          nameTop: c.finalNameTop,
          nameBottom: c.finalNameBottom,
          cap: c.finalCaption,
          dial: c.finalDial,
          dpre: c.finalDialPre,
          dsub: c.finalDialSub
        }
      ];
    }

    renderTiles() {
      var self = this;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < CARD_COUNT; i++) {
        var t = document.createElement('button');
        t.className = 'pc2b-tile';
        t.type = 'button';
        t.setAttribute('aria-label', 'Card ' + (i + 1) + ' of ' + CARD_COUNT + '. Tap to turn it over.');
        t.innerHTML =
          '<span class="pc2b-inner">' +
            '<span class="pc2b-face pc2b-back">' + ICON.crate + '<span class="pc2b-shine"></span></span>' +
            '<span class="pc2b-face pc2b-front"></span>' +
          '</span>';
        t.addEventListener('click', function (e) { self.onPick(e.currentTarget); });
        frag.appendChild(t);
        this.tiles.push(t);
      }
      this.el.grid.innerHTML = '';
      this.el.grid.appendChild(frag);
    }

    onPick(tile) {
      if (this.done || tile.classList.contains('is-open')) return;

      this.touched = true;
      var s = this.steps[this.opened];
      var front = tile.querySelector('.pc2b-front');

      front.className = 'pc2b-face pc2b-front' + (s.max ? ' is-max' : '');
      front.innerHTML = s.max
        ? '<span class="pc2b-pic">' + ICON[s.icon] + '</span>' +
          '<span class="pc2b-name">' + esc(s.nameTop) + '<br>' + esc(s.nameBottom) + '</span>' +
          '<span class="pc2b-cap">' + esc(s.cap) + '</span>'
        : '<span class="pc2b-num">' + esc(s.pct) + '</span>' +
          '<span class="pc2b-cap">' + esc(s.cap) + '</span>';

      tile.classList.add('is-open');
      tile.setAttribute('aria-label', (s.max ? s.nameTop + ' ' + s.nameBottom : s.pct) + ', ' + s.cap + '.');
      tile.setAttribute('aria-disabled', 'true');
      buzz(12);

      this.opened++;
      if (this.el.count) this.el.count.textContent = this.opened;
      if (this.el.bars[this.opened - 1]) this.el.bars[this.opened - 1].classList.add('is-on');

      var dial = this.el.dial;
      dial.classList.remove('is-idle', 'is-bump');
      dial.classList.toggle('is-word', !!s.max);
      dial.textContent = s.dial;
      this.el.pre.textContent = s.dpre || '';
      this.el.pre.classList.toggle('is-shown', !!s.dpre);
      this.el.dialSub.textContent = s.dsub || '';
      void dial.offsetWidth;
      dial.classList.add('is-bump');

      if (this.opened < PICKS) {
        var left = PICKS - this.opened;
        this.el.chip.textContent = this.cfg.chipProgress || 'Unlocking';
        this.el.nudge.textContent = 'Keep going. Turn ' + left + ' more card' + (left > 1 ? 's' : '');
      } else {
        this.finish();
      }
    }

    finish() {
      var self = this;
      var c = this.cfg;
      this.done = true;

      if (c.metaEvent && window.fbq) {
        try { window.fbq('trackCustom', c.metaEvent, { offer: c.code, variant: c.variant }); } catch (e) {}
      }

      this.tiles.forEach(function (t) {
        t.setAttribute('aria-disabled', 'true');
        if (!t.classList.contains('is-open')) t.setAttribute('aria-label', 'Card not turned.');
      });

      this.el.chip.textContent = c.chipDone || 'Unlocked';
      this.el.chip.classList.add('is-done');
      this.el.nudge.textContent = '';
      buzz([16, 60, 16, 60, 26]);
      if (c.confetti && !this.reduce) this.confetti();

      this.later(function () {
        if (c.timerMinutes > 0) self.startReservationTimer(c.timerMinutes);
        self.el.payoff.classList.add('is-shown');
        self.runPriceCountdown();
      }, 900);

      var payoff = this.el.payoff;
      payoff.addEventListener('transitionend', function onOpen(e) {
        if (e.target !== payoff || e.propertyName !== 'max-height' || !payoff.classList.contains('is-shown')) return;
        payoff.removeEventListener('transitionend', onOpen);
        payoff.style.maxHeight = 'none';
        if (self.el.price) self.el.price.scrollIntoView({ behavior: self.reduce ? 'auto' : 'smooth', block: 'center' });
        self.later(function () { self.showSticky(); }, 550);
      });
      /* fallback when transitionend never fires (reduced motion, hidden tab) */
      this.later(function () { self.showSticky(); }, 2600);
    }

    showSticky() {
      if (this.el.sticky) this.el.sticky.classList.add('is-shown');
    }

    /* the free box's price runs down to zero, then reads the final text */
    runPriceCountdown() {
      var self = this;
      var el = this.el.now;
      if (!el) return;
      var from = parseFloat(this.cfg.countFrom);
      var finalText = this.cfg.nowText || 'FREE';
      var end = function () {
        el.textContent = finalText;
        el.classList.add('is-bump');
      };
      if (this.reduce || !(from > 0)) { end(); return; }

      var t0 = null;
      var ms = 850;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min((ts - t0) / ms, 1);
        el.textContent = money(from * Math.pow(1 - k, 3));
        if (k < 1) self._raf = requestAnimationFrame(step);
        else end();
      }
      this._raf = requestAnimationFrame(step);
    }

    startReservationTimer(minutes) {
      var clock = this.el.clock;
      var out = this.el.clockValue;
      if (!clock || !out) return;
      var end = Date.now() + minutes * 60 * 1000;
      var timer;
      function tick() {
        var ms = Math.max(0, end - Date.now());
        var totalSec = Math.ceil(ms / 1000);
        out.textContent = pad(Math.floor(totalSec / 60)) + ':' + pad(totalSec % 60);
        clock.hidden = false;
        if (ms <= 0) clearInterval(timer);
      }
      tick();
      timer = setInterval(tick, 1000);
      this._timers.push(timer);
    }

    /* carry the ad's tracking onto the tier page the buttons link to.
       Shopify routing params (view, preview_theme_id, section_id, sections,
       _pos/_sid/_ss...) are skipped: copying ?view= would point the button
       back at this same template. */
    carryTrackingParams() {
      if (!window.URL || !window.URLSearchParams) return;
      var SKIP = ['view', 'preview_theme_id', 'section_id', 'sections'];
      var incoming = new URLSearchParams(window.location.search);
      if (!incoming.toString()) return;
      this.querySelectorAll('a[data-pc2b-cta]').forEach(function (a) {
        try {
          var u = new URL(a.href);
          incoming.forEach(function (v, k) {
            if (SKIP.indexOf(k) !== -1 || k.charAt(0) === '_') return;
            u.searchParams.set(k, v);
          });
          a.href = u.pathname + u.search + u.hash;
        } catch (err) { /* leave this link as authored */ }
      });
    }

    /* teach the affordance if they hesitate */
    scheduleHint() {
      var self = this;
      this.later(function () {
        var tile = self.tiles[4];
        if (self.touched || self.reduce || !tile || !tile.animate) return;
        tile.animate(
          [
            { transform: 'rotate(0) scale(1)' },
            { transform: 'rotate(-4deg) scale(1.05)' },
            { transform: 'rotate(4deg) scale(1.05)' },
            { transform: 'rotate(0) scale(1)' }
          ],
          { duration: 760, easing: 'ease-in-out' }
        );
      }, 2600);
    }

    confetti() {
      var host = this.el.confetti;
      if (!host) return;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < 46; i++) {
        var c = document.createElement('i');
        c.style.left = Math.random() * 100 + '%';
        c.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
        c.style.animationDuration = (1.5 + Math.random() * 1.5) + 's';
        c.style.animationDelay = (Math.random() * 0.35) + 's';
        c.style.transform = 'scale(' + (0.6 + Math.random() * 0.7) + ')';
        if (i % 3 === 0) c.style.borderRadius = '50%';
        frag.appendChild(c);
      }
      host.appendChild(frag);
      this.later(function () { host.innerHTML = ''; }, 3600);
    }
  }

  customElements.define('pick-card-2boxes-offer', PickCard2BoxesOffer);
})();
